import React from 'react';
import { AUIButtonCell } from '@ancert/aui-table-cell';
import { format } from 'date-fns';
import AUIEllipsis from '@ancert/aui-ellipsis';
import { FORMAT_DATE } from '../../../constants';
import { ROLES } from '../../../lib/role.enum';

const usuariosColumns = (verDetalleUsuario) => [
  {
    id: 'usuario',
    accessor: (row) => row,
    header: 'Usuario',
    cell: ({ value }) => {
      const { name, lastname1, lastname2 } = value;
      let fullName = 'Anónimo';
      if (name) {
        fullName = `${name} ${lastname1}${lastname2 ? ` ${lastname2}` : ''}`;
      }
      return <AUIEllipsis content={fullName}/>;
    },
  },
  {
    id: 'documentType',
    accessor: (row) => row?.documentType,
    columnWidth: 120,
    header: 'Tipo documento',
    cell: ({ value }) => <AUIEllipsis content={value}/>,
  },
  {
    id: 'documento',
    accessor: (row) => row?.document,
    columnWidth: 100,
    header: 'Doc. identidad',
    cell: ({ value }) => <AUIEllipsis content={value} />,
  },
  {
    id: 'email',
    accessor: (row) => row?.email,
    header: 'Correo electrónico',
    columnWidth: 220,
    cell: ({ value }) => <AUIEllipsis content={value}/>,
  },
  {
    id: 'rol',
    accessor: (row) => row?.role,
    columnWidth: 100,
    header: 'Rol',
    cell: ({ value }) => <>{ROLES.find(({ id }) => id === value)?.desc}</>,
  },
  {
    id: 'fecha',
    accessor: (row) => row?.creationDate,
    columnWidth: 96,
    header: 'Fecha',
    cell: ({ value }) => <>{format(new Date(value), FORMAT_DATE.FRONT)}</>,
  },
  {
    id: 'estado',
    accessor: (row) => row?.active,
    columnWidth: 70,
    header: 'Estado',
    cell: ({ value }) => <>{value ? 'Activo' : 'Inactivo'}</>,
  },
  {
    id: 'action',
    accessor: (row) => row,
    header: '',
    columnWidth: 48,
    cell: ({ value }) => (
      <AUIButtonCell
        buttonList={[
          {
            mode: 'ghost',
            label: 'Ver',
            onClick: () => {
              verDetalleUsuario(value?.id);
            },
          },
        ]}
      />
    ),
  },
];

export default usuariosColumns;
